export const FETCH_MOBILECOUNTRIES_REQUEST = "FETCH_MOBILECOUNTRIES_REQUEST";
export const FETCH_MOBILECOUNTRIES_SUCCESS = "FETCH_MOBILECOUNTRIES_SUCCESS";
export const FETCH_MOBILECOUNTRIES_FAILURE = "FETCH_MOBILECOUNTRIES_FAILURE";
export const FETCH_TERMS_TOPUP= "FETCH_TERMS_TOPUP";
export const FETCH_SERVICES_REQUEST = "FETCH_SERVICES_REQUEST";
export const FETCH_SERVICES_SUCCESS = "FETCH_SERVICES_SUCCESS";
export const FETCH_SERVICES_FAILURE = "FETCH_SERVICES_FAILURE";